import { Component, OnInit, EventEmitter, Output ,Inject, ViewChild} from '@angular/core';
import { FacilityService, SettingsService } from 'src/app/services';
import { IfacilityData } from 'src/app/models/facility/Ifacility';
import { BehaviorSubject } from 'rxjs';
import { SortEvent } from 'primeng/api/sortevent';
import {ProgressSpinnerModule} from 'primeng/progressspinner';
import { SettingsMainComponent } from 'src/app/components/settings/settings-main.component';
import {MessageService} from 'src/app/services/'
import { AccessUserInfo, UserDetail } from 'src/app/models';
@Component({
  selector: 'bart-setting-bart-vision',
  templateUrl: './setting-bart-vision.component.html',
  styleUrls: ['./setting-bart-vision.component.scss']
})
export class SettingBartVisionComponent implements OnInit {
  userId :any = this.parent.userDetail.userId;
  userName:any = this.parent.userDetail.userName
  columnlist: any[]; 
  vf: IfacilityData[]; hf:IfacilityData[];
  showInactiveFacilitiesYes: string;
  showInactiveFacilitiesNo: string;
  visibleFacCount: number; visibleFacCount$: BehaviorSubject<number> = new BehaviorSubject(0);
  hiddenFacCount: number; hiddenFacCount$: BehaviorSubject<number> = new BehaviorSubject(0);
  public bartRoleCode:string;
  selectedVisibleFacilities: IfacilityData;
  selectedHiddenFacilities: IfacilityData;
  gridloading:boolean= false;
  hideProgress:boolean= false; 
  showGlobalLoader:boolean=false;
  @ViewChild('Searchtb2', { static: false }) Searchtb2: any;
  @ViewChild('Searchtb', { static: false }) Searchtb: any;

  @Output() visionTabUserSettingEvent = new EventEmitter<object>();
  
  constructor(private settingsService: SettingsService, private _messageService:MessageService,
              private facilityService: FacilityService,
              @Inject(SettingsMainComponent) private parent: SettingsMainComponent
              ) { 
                let userInfo:UserDetail = AccessUserInfo.getUserInfo();
                if(userInfo!=null)
                {
                  this.bartRoleCode=userInfo.bartRoleCode
                }
            
              
  }

  ngOnInit(): void {
    this.columnlist = [
      { field: 'FacilityMasterID', header: 'FacilityMasterId',  display: 'none' },
      { field: 'FacilityNumber', header: 'ID',  display: 'table-cell' },
      { field: 'FacilityName', header: 'Location', display: 'table-cell' },
      { field: 'RegionName', header: 'Region', display: 'table-cell'  },
      { field: 'DivisionName', header: 'Division', display: 'table-cell' },
      
    ];

    this.hiddenFacCount$.subscribe(val =>this.hiddenFacCount=val);
    this.visibleFacCount$.subscribe(val =>this.visibleFacCount=val);

    this.populateFacilityDivs();
    this.getShowInactiveFacilities();
  }

  getShowInactiveFacilities() {

    var settingData;
    var args = {
      "GETUSERSETTING":{
      settingName:'showInactiveFacilities',
      UserID: this.userId

      }
    };

    this.settingsService.getUserSetting(JSON.stringify(args)).subscribe(
      data => {
 
        settingData = data;
        if (settingData.length> 0) {

          this.showInactiveFacilitiesYes= settingData[0].value;
 
          }
        else { 
          this.showInactiveFacilitiesYes= "0";
        }
      }, 
      err=> {}, 
      () => {}
    );

  }

  //Event Emitter to parent method call setUserSetting(settingObj)
  CallUserSettings(settingObj){  
    this.setFacilitySetting(settingObj);


  }

  setFacilitySetting(settingObj)
  { 
    var args = {
      "SETUSERSETTING" : {
        settingName: "showInactiveFacilities",
        userId : this.userId,
        ValueList: settingObj.value
      }     
    }; 
    this.settingsService.setUserSetting(JSON.stringify(args)).subscribe(
      data => {
        var settingData = data;
        localStorage.removeItem("getUserFacilities");
        localStorage.removeItem("getUserLocations");
        this.populateFacilityDivs(); 
        
      },
      err => {
        return console.log(err);
      },
      () => {
        console.log(`Settings saved`);
      }
    );
  }
  
  populateFacilityDivs() {
    var gridData: Array<any[]>; 
	  var hiddenGridData: Array<any[]>; 
	  var i = null;
    var facilityData = null;
    this.gridloading =true;
   
    var facilityObj = {      
      "GETUSERFACILITIES": {
        "USERNAME": this.userName,
        "SORTCOL": "",
        "LOCATION_ID_LIST": ""
    },
    "GETUSERLOCATIONS2": {
        "USERNAME": this.userName
    }
  }
    
  
    this.facilityService.getUserFacilities(JSON.stringify(facilityObj)).subscribe(
      data=>{  
      this.vf = data.userFacilities; this.visibleFacCount = this.vf.length;
      this.hf = data.hiddenFacilities; 
      this.hiddenFacCount$.next(this.hf.length);  this.visibleFacCount$.next(this.vf.length); 
       this.hideProgress= true;
      this.gridloading=false;
      }, 
      err => { }, 
      () => {}
    );

  }

  makeAllHidden()
  { 
    this.hf.push(...this.vf);
    this.vf=[];
    this.hiddenFacCount$.next(this.hf.length); this.visibleFacCount$.next(this.vf.length);
    this.Searchtb2.reset();
    this.Searchtb.reset();
  }

  makeAllVisible()
  { 
    this.vf.push(...this.hf);
    this.hf=[];
    this.hiddenFacCount$.next(this.hf.length); this.visibleFacCount$.next(this.vf.length);
    this.Searchtb2.reset();
    this.Searchtb.reset();
  }

  //----Start - swapping selected row data 
  onVisibleFacilityRowSelect(event) {     
    if(event.data != undefined) {   
      let temphf:IfacilityData[]=[];
      if(this.hf.length>0)
      {
        temphf=Object.assign([{}], this.hf);
      }
      this.selectedVisibleFacilities = event.data;
      temphf.push(this.selectedVisibleFacilities); 
      this.hf=[];
      this.hf=temphf
      this.deleteVfRow();     
      this.hiddenFacCount$.next(this.hf.length); this.visibleFacCount$.next(this.vf.length);
      //this.Searchtb2.reset();
      //this.Searchtb.reset();
    }
  }

  onHiddenFacilityRowSelect(event) {     
    if(event.data != undefined) {
      let tempvf:IfacilityData[]=[];
      if(this.vf.length>0)
      {
        tempvf=Object.assign([{}], this.vf);
      }
      this.selectedHiddenFacilities = event.data;
      tempvf.push(this.selectedHiddenFacilities);
      this.vf=[];
      this.vf=tempvf;
      this.deletehfRow();  
      this.hiddenFacCount$.next(this.hf.length); this.visibleFacCount$.next(this.vf.length);
      //this.Searchtb2.reset();
      //this.Searchtb.reset();
    }

  }



  saveFacilityChanges()
  {
    this.showGlobalLoader=true;
    const selectedFacilityMasterId = AccessUserInfo.getSelectedFacilityMasterId();
    let hiddenFacilities = Array.prototype.map.call(this.hf, function(item) { return item.FacilityMasterID; });
    const hasFacilityMasterMovedToHidden = hiddenFacilities.includes(selectedFacilityMasterId);
    var args = {
      "SETUSERSETTING" : {
        settingName: "hideFacility",
        userId : this.userId,
        ValueList: hiddenFacilities.join(",")
      }     
    };
    // var setObj = this.settingsService.setUserSetting(args);
    this.settingsService.setUserSetting(JSON.stringify(args)).subscribe(
      data => {
        this.showGlobalLoader=false;
        localStorage.removeItem("getUserLocations");
        // Remove local storage facility masted id when selected facility moved to hidden 
        if (hasFacilityMasterMovedToHidden) {
          sessionStorage.removeItem("FacilityMasterId");
        }
        this._messageService.showAlertMessage("Setting saved successfully");
        var settingData = data;
      },
      err => {
        this.showGlobalLoader=false;
        return console.log(err);
      },
      () => {
        this.showGlobalLoader=false;
        console.log(`Settings saved`);
      }
    );
  }

  deleteVfRow() {
    let index = this.vf.indexOf(this.selectedVisibleFacilities);
    this.vf = this.vf.filter((facilityData,i)=> i != index);
  }

  deletehfRow() {
    let index = this.hf.indexOf(this.selectedHiddenFacilities);
    this.hf = this.hf.filter((facilityData,i)=> i != index);
  }
  //---------End - Swapping selected row data -----------

  sortFacilitiesData(event: SortEvent) {
    event.data.sort((data1, data2) => {
        let value1 = data1[event.field];
        let value2 = data2[event.field];
        let result = null;

        if (value1 == null && value2 != null)
            result = -1;
        else if (value1 != null && value2 == null)
            result = 1;
        else if (value1 == null && value2 == null)
            result = 0;
        else if (typeof value1 === 'string' && typeof value2 === 'string')
            result = value1.localeCompare(value2);
        else
            result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

        return (event.order * result);
    });
  }
 
 public hasPermission()
  {
    let result:Boolean=false
    if("ADMIN,BOM".split(",").indexOf(this.bartRoleCode)>-1)
    {
      result= true;
      
    }
    return result
  }



}
